import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=0877f41e&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=0877f41e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0877f41e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0877f41e')) {
      api.createRecord('0877f41e', component.options)
    } else {
      api.reload('0877f41e', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=0877f41e&scoped=true&", function () {
      api.rerender('0877f41e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2YdCSMFMGpANv/JS/comp/DateRangeExt.vue"
export default component.exports